module.exports = __webpack_public_path__ + "static/media/usecasesection1.0e2379db.png";